"use client";

import React from "react";
import styled from "styled-components";
import { useKeenSlider } from "keen-slider/react";
import { OfferType } from "@motorata/base-ui.types.api";
import { Box, Row } from "@motorata/base-ui.components.atoms._atoms";
import { LabelH2 } from "@motorata/base-ui.components.atoms.typography";
import { IconButton } from "@motorata/base-ui.components.atoms.button";
import OfferBlock from "@/components/shared/OfferBlock";

const ArticleSliderSection = ({ title, offers }: {
  title: string,
  offers: OfferType[]
}) => {

  const [sliderRef, slider] = useKeenSlider({
    loop: false,
    breakpoints: {
      "(min-width: 600px)": {
        slides: { perView: 2 }
      },
      "(min-width: 1000px)": {
        slides: { perView: 3 }
      },
      "(min-width: 1500px)": {
        slides: { perView: 4 }
      }
    },
    slides: { perView: 1 }
  });

  const handleNext = () => {
    slider.current?.next();
  };

  const handlePrev = () => {
    slider.current?.prev();
  };

  return (
    <Wrapper>
      <ButtonsWrapper marginBottom="S">
        <LabelH2 margin="0">
          {title}
        </LabelH2>
        <ButtonsContent>
          <IconButton
            size="XL"
            onClick={handlePrev}
            icon="arrow-left"
            style={{
              borderRadius: 3
            }}
          />
          <IconButton
            size="XL"
            onClick={handleNext}
            icon="arrow-right"
            style={{
              borderRadius: 3
            }}
          />
        </ButtonsContent>
      </ButtonsWrapper>
      <Content ref={sliderRef} className="keen-slider">
        {
          offers?.map((offer, index) =>
            <Box className="keen-slider__slide" key={index} paddingLeft="XS" paddingRight="XS">
              <OfferBlock column offer={offer} height="100%" />
            </Box>
          )
        }
      </Content>
    </Wrapper>
  );
};

export default ArticleSliderSection;

const ButtonsWrapper = styled(Row)`
  justify-content: space-between;
  align-items: center;
`;

const ButtonsContent = styled(Row)`
  grid-gap: ${({ theme }) => theme.space.S};
`;

const Content = styled.div`
  width: 100vw !important;
  margin-left: calc((100vw - 100%) / -2);

`;

const Wrapper = styled(Box)`

`;
